module.exports = __webpack_public_path__ + "static/img/smfw_tzjsmfw_swkc.3c20ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smfw_tzjsmfw_swkc.png
// module id = Ph0Y
// module chunks = 21